import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";
import Home from "./components/Home";
import About from "./components/About";
import Footer from "./components/Footer";
import CustomNavbar from "./components/Navbar";
import Products from "./components/Products";
import Services from "./components/Services";
import AdminPage from "./components/AdminPage";
import Inventory from './components/Inventory';

const App = () => {
  return (
    <BrowserRouter>
      <div className="min-vh-100 d-flex flex-column">
        <CustomNavbar />
        <main className="flex-grow-1 my-5">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
